import { ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import Reveal from "./Reveal";

const DivisionCard = ({
  tone = "primary", // 'primary' | 'secondary' | 'accent'
  image,
  badge,
  name,
  tag,
  intro,
  items = [],
  testid,
  link = "/contact",
  cta = "Explore Division",
}) => {
  const isPrimary = tone === "primary";
  return (
    <Reveal>
      <article
        data-testid={testid}
        className={`group relative overflow-hidden border ${
          isPrimary
            ? "bg-[#0A192F] text-white border-[#0A192F]"
            : "bg-white text-[#0A192F] border-gray-200"
        } transition-all hover:shadow-2xl`}
      >
        <div className="relative h-64 sm:h-72 overflow-hidden">
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105"
            loading="lazy"
          />
          <div className={`absolute inset-0 ${isPrimary ? "bg-[#0A192F]/55" : "bg-[#0A192F]/30"}`} />
          <span className="absolute top-5 left-5 text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] bg-black/30 backdrop-blur px-3 py-1.5">
            {badge}
          </span>
        </div>

        <div className="p-8 lg:p-10">
          <h3 className="font-serif text-2xl sm:text-3xl tracking-tight">
            {name}
          </h3>
          <p className={`mt-2 text-sm uppercase tracking-[0.2em] ${isPrimary ? "text-[#D4AF37]" : "text-[#D4AF37]"}`}>
            {tag}
          </p>
          <p className={`mt-5 leading-relaxed ${isPrimary ? "text-gray-300" : "text-gray-600"}`}>
            {intro}
          </p>

          <ul className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
            {items.map((it) => (
              <li key={it} className="flex items-start gap-2 text-sm">
                <Check className={`w-4 h-4 mt-0.5 shrink-0 ${isPrimary ? "text-[#D4AF37]" : "text-[#D4AF37]"}`} />
                <span className={isPrimary ? "text-gray-200" : "text-gray-700"}>{it}</span>
              </li>
            ))}
          </ul>

          <Link
            to={link}
            data-testid={`${testid}-cta`}
            className={`mt-8 inline-flex items-center gap-2 text-sm uppercase tracking-[0.25em] font-medium border-b pb-1 transition-colors ${
              isPrimary
                ? "text-white border-white/40 hover:text-[#D4AF37] hover:border-[#D4AF37]"
                : "text-[#0A192F] border-[#0A192F]/30 hover:text-[#D4AF37] hover:border-[#D4AF37]"
            }`}
          >
            {cta} <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </article>
    </Reveal>
  );
};

export default DivisionCard;
